module.exports = __webpack_public_path__ + "static/media/train12.9071cad9.png";